import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { BASELINE } from '../../util';
import { UserContext } from '../../context/UserContext';

// 로그인한 날짜가 채워지는 미니멀 출석 캘린더 (전체 폭)
const AttendanceCalendar = () => {
    const { user } = useContext(UserContext);
    const [days, setDays] = useState(new Set());

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-based
    const today = now.getDate();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();
    const monthLabel = now.toLocaleString('en-US', { month: 'long', year: 'numeric' });

    useEffect(() => {
        if (!user?.u_id) return;
        // 오늘 출석 기록 후 이번 달 출석 날짜 조회
        axios.post(BASELINE + 'attendance/checkin', { u_id: user.u_id })
            .catch(() => { })
            .finally(() => {
                axios.get(BASELINE + 'attendance', {
                    params: { u_id: user.u_id, year, month: month + 1 },
                })
                    .then(({ data }) => {
                        setDays(new Set((data || []).map(d => parseInt(d.slice(8, 10), 10))));
                    })
                    .catch(() => { });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return (
        <div className="max-w-2xl mx-auto mb-8">
            <div className="flex items-baseline justify-between mb-2">
                <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-[0.2em]">Attendance</p>
                <p className="text-[10px] font-medium text-slate-400">{monthLabel}</p>
            </div>
            <div className="grid grid-cols-7 gap-y-1.5 justify-items-center">
                {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => (
                    <span key={`w${i}`} className="text-center text-[9px] text-slate-300 font-semibold mb-0.5">{d}</span>
                ))}
                {Array.from({ length: firstDay }).map((_, i) => (
                    <span key={`e${i}`} />
                ))}
                {Array.from({ length: daysInMonth }).map((_, i) => {
                    const d = i + 1;
                    const filled = days.has(d);
                    const isToday = d === today;
                    return (
                        <div
                            key={d}
                            title={`${monthLabel} ${d}`}
                            className={`w-6 h-6 rounded-md flex items-center justify-center border transition-colors duration-200
                                ${filled ? 'bg-blue-500 border-blue-600' : 'bg-transparent border-slate-400'}
                                ${isToday ? 'ring-1 ring-blue-400 ring-offset-1 ring-offset-[#eef2f7]' : ''}`}
                        >
                            <span className={`text-[9px] font-medium ${filled ? 'text-white' : 'text-slate-500'}`}>{d}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AttendanceCalendar;
